import React from "react";

const SparkleIcon = ({ className = "" }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M16 19a1 1 0 0 1 0 -2a1 1 0 0 0 1 -1c0 -1.333 2 -1.333 2 0a1 1 0 0 0 1 1c1.333 0 1.333 2 0 2a1 1 0 0 0 -1 1c0 1.333 -2 1.333 -2 0a1 1 0 0 0 -1 -1" />
    <path d="M3 11a5 5 0 0 0 5 -5c0 -1.333 2 -1.333 2 0a5 5 0 0 0 5 5c1.333 0 1.333 2 0 2a5 5 0 0 0 -5 5a1 1 0 0 1 -2 0a5 5 0 0 0 -5 -5c-1.333 0 -1.333 -2 0 -2" />
    <path d="M16 7a1 1 0 0 1 0 -2a1 1 0 0 0 1 -1c0 -1.333 2 -1.333 2 0a1 1 0 0 0 1 1c1.333 0 1.333 2 0 2a1 1 0 0 0 -1 1c0 1.333 -2 1.333 -2 0a1 1 0 0 0 -1 -1" />
  </svg>
);

export default function AISummaryWidget({ title = "AI insights summary", text, loading }) {
  const raw = typeof text === "string" ? text : "";
  // Split only on the first "Suggestion:" to preserve any later occurrences in the suggestion text
  const suggestionIdx = raw.search(/Suggestion:\s*/i);
  const hasSuggestion = suggestionIdx !== -1;
  const beforeSuggestion = hasSuggestion ? raw.slice(0, suggestionIdx) : raw;
  const afterSuggestion = hasSuggestion ? raw.slice(suggestionIdx).replace(/^Suggestion:\s*/i, "") : "";

  return (
    <div className="rounded-lg border border-[#E7E3FF] bg-[#F7F6FF] p-5 shadow-subtle h-[360px] flex flex-col">
      <div className="flex items-start justify-between">
        <h3 className="text-sm font-normal text-black-0">{title}</h3>
      </div>

      <div>
        <SparkleIcon className="text-brand" />
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto pr-2">
        {loading ? (
          <div className="space-y-3">
            <div className="h-4 w-11/12 rounded bg-[#ECEAFB]" />
            <div className="h-4 w-10/12 rounded bg-[#ECEAFB]" />
            <div className="h-4 w-11/12 rounded bg-[#ECEAFB]" />
            <div className="h-4 w-9/12 rounded bg-[#ECEAFB]" />
            <div className="h-4 w-10/12 rounded bg-[#ECEAFB]" />
          </div>
        ) : (
          <div className="text-sm leading-relaxed text-black-0 tracking-[-0.5px] whitespace-pre-wrap">
            {raw ? (
              hasSuggestion ? (
                <>
                  <span>{beforeSuggestion.trim()}</span>
                  <br />
                  <br />
                  <span className="font-semibold">Suggestion</span>
                  <span>: {afterSuggestion.trim()}</span>
                </>
              ) : (
                raw
              )
            ) : (
              "No summary available for the selected period."
            )}
          </div>
        )}
      </div>
    </div>
  );
}

